import propTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Card from 'react-bootstrap/Card';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';
import { addConference, getConferenceBookings, getConferences } from '../../actions/conference';

const AddConference = ({ addConference, getConferenceBookings, getConferences, auth }) => {

    useEffect(() => {
        getConferences()
    }, [getConferences])
    
    useEffect(() => {
        getConferenceBookings()
    }, [getConferenceBookings])

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        name: '',
        description: '',
        rent: '',
        imageurl1: '',
        imageurl2: '',
        imageurl3: ''
    })

    const {
        name,
        description,
        rent,
        imageurl1,
        imageurl2,
        imageurl3
    } = formData;

    const onChange = (e) =>
        setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = (e) => {
        e.preventDefault();
        addConference(formData, navigate);
    };
  
    return (
        <div className='container' style={{maxWidth: "650px"}}>
        <Card border="warning">
            <Card.Header>Enter Conference Information</Card.Header>
            <Card.Body>
                <form style={{ textAlign: "center" }} className="form" onSubmit={ e => onSubmit(e)}>

                    <label>Conference Name
                        <input type='text' placeholder='Conference Name' name="name" value={name} required onChange={e => onChange(e)} />
                    </label>
                    <label>Rent
                        <input type="text" placeholder='Rent' name="rent" value={rent} required onChange={e => onChange(e)} />
                    </label>
                    <br />
                    <label>Image Link 1
                        <input type="text" placeholder='Image Link 1' name="imageurl1" value={imageurl1} onChange={e => onChange(e)} />
                    </label>

                    <label>Image Link 2
                        <input type="text" placeholder='Image Link 2' name="imageurl2" value={imageurl2} onChange={e => onChange(e)} />
                    </label>
                    
                    <label>Image Link 3
                        <input type="text" placeholder='Image Link 3' name="imageurl3" value={imageurl3} onChange={e => onChange(e)} />
                    </label>
                    <br />

                    <label>Description
                        <input type='text' placeholder='Conference Description' name="description" value={description} size="150" required onChange={e => onChange(e)} />
                    </label>
                    <br />
                
                    <input type="submit" className="btn btn-success" value="Add Conference" /> 
                </form>
            </Card.Body>
        </Card>
        </div>
    )
}

AddConference.propTypes = {
  addConference: propTypes.func.isRequired,
  auth: propTypes.object.isRequired,
  getConferences: propTypes.func.isRequired,
  getConferenceBookings: propTypes.func.isRequired,
  conference: propTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  conference: state.conference
});

export default connect(mapStateToProps, { addConference, getConferenceBookings, getConferences })(AddConference);